import { render, staticRenderFns } from "./Anima.vue?vue&type=template&id=6a3ae7e7"
import script from "./Anima.vue?vue&type=script&lang=js"
export * from "./Anima.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports